/* src/app/modules/shared/components/header-column/header-column-flavor/header-column-flavor.component.scss */
app-header-column-flavor {
  display: contents;
}
/*# sourceMappingURL=header-column-flavor.component.css.map */
